import { IBodyResponse } from '@/common/interfaces';
import { ApiService } from '@/common/services/api';
import service from '@/plugins/axios';

class ImportJobService extends ApiService {
    async importJob(payload: FormData) {
        return await this.client.post<any, IBodyResponse<any>>(
            `${this.baseUrl}`,
            payload,
        );
    }

    async getImportJobStatus(planningId: string) {
        return await this.client.get<any, IBodyResponse<any>>(
            `${this.baseUrl}/pending-job`,
            {
                params: {
                    planningId,
                },
            },
        );
    }
}

export const importJobService = new ImportJobService({ baseUrl: '/import-job' }, service);
